import { array } from 'fp-ts';
import { Stack } from '@optimus-web/core';
import { useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { GuestSmartTips } from '../../../../guestSmartTips/components/guestSmartTips';
import { GuestDetailEmptyContent } from './components';
import { GuestOverview, GuestOverviewProps } from './GuestOverview';
import { LoyaltyOverview, LoyaltyOverviewProps } from './Loyalty';
import { ReservationsOverview, ReservationsOverviewProps } from './Reservations';

interface GuestDetailContentProps {
    guestId: string;
    guestSummary: (GuestOverviewProps & LoyaltyOverviewProps & ReservationsOverviewProps) | undefined;
}

export const GuestDetailContent = ({ guestId, guestSummary }: GuestDetailContentProps) => {
    const gxGuestAiSmartTipsGuestProfilePage = useFeatureFlag(FeatureFlag.gxGuestAiSmartTipsGuestProfilePage);

    if (!guestSummary) {
        return null;
    }

    const { loyaltyMemberships, reservations, ...other } = guestSummary;

    const hasLoyaltyMemberships = array.isNonEmpty(loyaltyMemberships);
    const hasReservations = array.isNonEmpty(reservations);

    return (
        <Stack vertical spacing="300">
            <GuestOverview {...other} loyaltyMemberships={loyaltyMemberships} />
            <GuestSmartTips guestId={guestId} useAssistantApi={!gxGuestAiSmartTipsGuestProfilePage} />
            {hasLoyaltyMemberships ? <LoyaltyOverview loyaltyMemberships={loyaltyMemberships} /> : null}
            {hasReservations ? <ReservationsOverview reservations={reservations} /> : null}
            {!hasLoyaltyMemberships && !hasReservations ? <GuestDetailEmptyContent id={guestId} /> : null}
        </Stack>
    );
};
